import React from "react";
import JSZip from "jszip";

function PackImporter({ onImportFiles }) {
  const handleImport = async (event) => {
    const file = event.target.files[0];
    if (!file) return;
    try {
      const zip = await JSZip.loadAsync(file);
      // Get the chest_screen.json file from the ui folder
      const chestScreenFile = zip.file("ui/chest_screen.json");
      if (!chestScreenFile) {
        alert("Invalid pack: chest_screen.json not found in the ui folder.");
        return;
      }
      const content = await chestScreenFile.async("string");
      const chestScreenJSON = JSON.parse(content);

      // Try to load offsets.json from the ui folder
      let offsetsData = null;
      const offsetsFile = zip.file("ui/offsets.json");
      if (offsetsFile) {
        const offsetsContent = await offsetsFile.async("string");
        offsetsData = JSON.parse(offsetsContent);
      } else {
        alert(
          "Offset values file missing from imported pack. Default offsets will be used this time."
        );
      }

      // Default keys to ignore
      const defaultKeys = [
        "ofunnys_chest_panel",
        "ofunnys_ia_categories@ofunnys_ia_categories",
        "ofunnys_ia_crafting@ofunnys_ia_crafting",
        "ofunnys_chest_panels",
        "large_chest_panel",
        "small_chest_panel",
        "small_chest_screen@common.inventory_screen_common",
        "large_chest_screen@common.inventory_screen_common",
      ];

      const importedFiles = [];

      // Loop through all keys in chest_screen JSON
      for (let key in chestScreenJSON) {
        if (defaultKeys.includes(key)) continue;
        if (key.includes("@")) {
          const entry = chestScreenJSON[key];
          if (
            entry.texture &&
            entry.texture.startsWith("textures/ui/pogmc_converter/")
          ) {
            const texturePathParts = entry.texture.split("/");
            let fileName = texturePathParts[texturePathParts.length - 1];
            // Normalize key as in JSONGenerator:
            let keyFromOffsets = fileName;
            if (!fileName.toLowerCase().endsWith(".png")) {
              keyFromOffsets += ".png";
            }
            keyFromOffsets = keyFromOffsets.toLowerCase();

            let char = "";
            if (entry.visible) {
              const match = entry.visible.match(/'([^']+)'/);
              if (match) {
                char = match[1];
              }
            }

            // Default values
            let xOffset = 8, yOffset = 42, includeBackground = true;
            if (offsetsData && offsetsData[keyFromOffsets] !== undefined) {
              xOffset = offsetsData[keyFromOffsets].xOffset;
              yOffset = offsetsData[keyFromOffsets].yOffset;
              // Explicitly check if includeBackground is defined.
              if (typeof offsetsData[keyFromOffsets].includeBackground === "boolean") {
                includeBackground = offsetsData[keyFromOffsets].includeBackground;
              }
            }

            const textureFile = zip.file(`textures/ui/pogmc_converter/${fileName}`);
            if (textureFile) {
              const blob = await textureFile.async("blob");
              importedFiles.push({
                imported: true,
                id: key,
                name: fileName,
                char,
                file: blob,
                xOffset,
                yOffset,
                includeBackground,
              });
            }
          }
        }
      }

      onImportFiles(importedFiles);
    } catch (error) {
      console.error("Error importing pack", error);
      alert("Failed to import pack.");
    }
  };

  return (
    <div className="pack-importer">
      <h2>Import Existing .mcpack</h2>
      <input
        type="file"
        accept=".mcpack"
        onChange={handleImport}
        className="file-input styled-input"
        id="pack-import-input"
      />
      <label htmlFor="pack-import-input" className="styled-input-label">
        Choose Pack
      </label>
    </div>
  );
}

export default PackImporter;
